//@flow
import React from 'react';
import classNames from 'classnames';
import { useViewport } from 'components/templates/viewportProvider';
import ShareIconWhite from 'assets/images/share-white.png';
import ShareIconSvg from 'assets/images/Icons_share.svg';
import ShareIconBlack from 'assets/images/share.png';
//eslint-disable-next-line
import styles from "./style.scss";

type Props = {
  onClick: void,
  mode: string,
  shareButtonClassName?: string,
};

export const ShareButton = (props: Props) => {
  const { isMobile } = useViewport();
  const { shareButtonClassName, mode, onClick } = props;

  const buttonClassNames = classNames(
    'share-button',
    shareButtonClassName,
    mode
  );

  return (
    <button className={buttonClassNames} onClick={onClick}>
      <img
        // src={mode === 'light' ? ShareIconBlack : ShareIconWhite}
        src={isMobile ? ShareIconSvg : ShareIconWhite}
        alt={'share'}
      />
    </button>
  );
};
